/**
 * The one owner of `document.title`.
 *
 * Two things want to write it: a page saying which page it is, and the tab
 * alert saying somebody is waiting. When each captured the current title and
 * restored it afterwards, they clobbered each other — the alert would restore
 * the title from before a navigation, and a page unmounting mid-blink would
 * restore a blink frame and leave the tab reading "● New message" with nothing
 * blinking behind it.
 *
 * So neither of them stores a title. They each declare their own layer, and
 * this decides what shows: the alert when there is one, the page otherwise.
 */

/** What index.html shipped with — the title when nothing has an opinion. */
const DEFAULT = document.title || 'LeadGab';

let page: string | null = null;
let alert: string | null = null;

function render(): void {
  document.title = alert ?? page ?? DEFAULT;
}

/** The page's own title. `null` gives the app name back. */
export function setPageTitle(title: string | null): void {
  page = title;
  render();
}

/** The blinking overlay. `null` drops back to whatever page is open. */
export function setAlertTitle(title: string | null): void {
  alert = title;
  render();
}
